import React from 'react'
import './style.scss'
import TestimonialItem from './TestimonialItem';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import { SwiperOptions } from "swiper";
import ControlNav from "../slider-portfolio/ControlNav";
import { dsnCN } from "../../hooks/helper";

const TestimonialDetails = [
    {
        authorName: "Emily",
        description: `Listening felt like stepping into a forest I’ve never seen, yet somehow remembered. Every note carried me deeper into hidden worlds.`
    },
    {
        authorName: "James",
        description: `The meditation guided me along rivers I didn’t know existed, with music that felt alive and aware of me.`
    },
    {
        authorName: "Sophie",
        description: `Each podcast is a lantern in a dark realm — illuminating corners of imagination I’d never wandered before.`
    },
    {
        authorName: "Michael",
        description: `Your music made me feel nostalgia for places I’ve never visited, yet they called to me as if they were home.`
    },
    {
        authorName: "Olivia",
        description: `It’s like the songs know my footsteps, the stories know my shadow. I step through and feel a world I cannot touch — but can feel.`
    }
]


function TestimonialTow({ className, ...restProps }: SwiperOptions) {
    return (

        <section className={dsnCN('dsn-testimonial testimonial-tow', className)}>
            <div className="testimonial-inner">
                <div className='content-box'>
                    <Swiper slidesPerView={1} {...restProps} >
                        {TestimonialDetails.map(
                            (item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <TestimonialItem
                                            authorName={item.authorName} label={item.label}
                                            description={item.description} />
                                    </SwiperSlide>
                                );
                            }
                        )}
                        <ControlNav />

                    </Swiper>
                </div>
            </div>
        </section>

    )
}


export default TestimonialTow;